import "./App.css";
import "rsuite/dist/rsuite.min.css";
import "react-perfect-scrollbar/dist/css/styles.css";
import "bootstrap/dist/css/bootstrap.min.css";
import "react-datepicker/dist/react-datepicker.css";
import "./assets/css/navbar.scss";
import "./assets/css/font.scss";
import "./assets/css/general.scss";
import "./assets/css/helper.scss";
import "./assets/css/footer.scss";
import "./assets/css/icon.scss";
import "./assets/css/switch.scss";
import "react-modal-video/scss/modal-video.scss";
import { Footer } from "./components";
import { useRef, useEffect, useLayoutEffect } from "react";
import languageRedux, {
  languageSelector,
  languagesSelector,
} from "./redux/languages";
import Navbar from "./components/Navbar";
import { useDispatch, useSelector } from "react-redux";
import ScrollBar from "react-perfect-scrollbar";
import { Navigate, Route, Routes, useLocation } from "react-router-dom";
import { nonauthRoutes } from "./routes";
import { ToastContainer } from "react-toastify";
import DirectionProvider, {
  DIRECTIONS,
  //@ts-ignore
} from "react-with-direction/dist/DirectionProvider";
import { Helmet } from "react-helmet";
import { Homepage } from "./pages";
const AlwaysScrollToBottom = () => {
  const location = useLocation();
  const elementRef = useRef(null);
  useEffect(() => {
    //@ts-ignore
    elementRef.current.scrollIntoView();
  }, [location.pathname]);
  return <div ref={elementRef} />;
};

function App() {
  const language = useSelector(languageSelector);
  const dispatch = useDispatch();
  const location = useLocation();
  // const getLanguages = async () => {
  //   // await dispatch(languageRedux.actions.getLanguages());
  //   const lang = window.location.pathname.split("/")[1];
  //   if (lang && !language.Code.includes(lang)) {
  //     const currentLang = languages.find((x) => x.Code.includes(lang));
  //     currentLang && dispatch(languageRedux.actions.setLanguage(currentLang));
  //   } // eslint-disable-next-line
  // };

  useLayoutEffect(() => {
    if (language.Code != "en-US") {
      dispatch(
        languageRedux.actions.setLanguage({
          Code: "en-US",
          EnumId: "73338890-d4e0-4976-90ed-6953286a824f",
          Name: "English",
        })
      );
    }
  }, [dispatch]);
  return (
    <DirectionProvider
      direction={language.Code.includes("ar") ? DIRECTIONS.RTL : DIRECTIONS.LTR}
      lang={language.Code.split("-")[0]}
    >
      <div className="App ">
        <Helmet htmlAttributes={{ lang: language.Code.split("-")[0] }} />
        <Navbar />
        <ToastContainer
          position="top-center"
          autoClose={2000}
          hideProgressBar={false}
          newestOnTop={false}
          closeOnClick={true}
          rtl={false}
          pauseOnFocusLoss={false}
          draggable
          pauseOnHover
        />
        <ScrollBar style={{ overflowX: "hidden" }}>
          <AlwaysScrollToBottom />

          <Routes>
            {nonauthRoutes.map((route, idx) => (
              <Route path={route.path} element={route.element} />
            ))}
            <Route
              path="/:lang/pricing"
              element={<Navigate to="/pricing" replace />}
            />
            <Route
              path="/:lang/solutions"
              element={<Navigate to="/solutions" replace />}
            />
            <Route
              path="/:lang/solutions/:sectorseo/:moduleseo"
              element={<Navigate to="/solutions" replace />}
            />
            <Route path="*" element={<Navigate to="/" replace />} />
          </Routes>
          <Footer />
        </ScrollBar>
      </div>
    </DirectionProvider>
  );
}

export default App;
